(() => {
const mobile = window.matchMedia('(max-width: 768px)');
const originalStyles = new Map();
let frameId;

function restore(chat, original) {
    if (original.value) {
    chat.style.setProperty('bottom', original.value, original.priority);
    } else {
    chat.style.removeProperty('bottom');
    }
}

function updatePosition() {
    const bar = document.querySelector('#opus-stc-widget__bar');
    const chats = document.querySelectorAll('.shp-cnv-shipway-chat');
    const viewportHeight = window.innerHeight;
    const rect = bar?.getBoundingClientRect();
    const style = bar && getComputedStyle(bar);

    const isVisible =
    mobile.matches &&
    rect &&
    rect.width > 0 &&
    rect.height > 0 &&
    rect.top < viewportHeight &&
    rect.bottom > 0 &&
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    Number(style.opacity) > 0;

    chats.forEach((chat) => {
    if (!originalStyles.has(chat)) {
        originalStyles.set(chat, {
        value: chat.style.getPropertyValue('bottom'),
        priority: chat.style.getPropertyPriority('bottom')
        });
    }

    const original = originalStyles.get(chat);

    if (!isVisible) {
        restore(chat, original);
        return;
    }

    /* Read the default offset before applying the adjustment */
    restore(chat, original);
    const defaultBottom = parseFloat(getComputedStyle(chat).bottom) || 0;

    /* Keep a 12px gap above the visible sticky bar */
    const bottom = Math.max(
        defaultBottom,
        viewportHeight - rect.top + 3
    );

    chat.style.setProperty('bottom', `${Math.ceil(bottom)}px`, 'important');
    });

    for (const chat of originalStyles.keys()) {
    if (!chat.isConnected) originalStyles.delete(chat);
    }

    frameId = requestAnimationFrame(updatePosition);
}

/* Track size changes, delayed loading, and slide animations */
frameId = requestAnimationFrame(updatePosition);

window.addEventListener('pagehide', () => {
    cancelAnimationFrame(frameId);
    originalStyles.forEach((original, chat) => restore(chat, original));
});

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
    frameId = requestAnimationFrame(updatePosition);
    }
});
})();